
import { CommonFunctions } from '../static/common-functions';
import { DateFunctions } from '../static/date-functions';
import { AppClaims } from '../models/AppClaims';

export class OrderSecurity  {

    currentStatus: string;

    pending: string = "CB2F27B0-3599-48CC-A18B-A4B7D787E565".toLowerCase();
    ordered: string = "3D2C81F2-4DC7-44FC-B2E0-D462693F5F19".toLowerCase();
    fullyReceived: string = "B947AC2A-25B2-4D4F-96B4-F3D53970D554".toLowerCase();
    billEntered: string = "CF2E692A-F848-4E0C-B4D4-D6439B4050FE".toLowerCase();
    canceled: string = "1CD15F2C-A5A0-4D61-86AF-2582F1634856".toLowerCase();
    completed: string = "FA457C0E-D19A-458A-BE69-2C4F0ADABFD6".toLowerCase();
    partiallyReceived: string = "5D4FE806-19F8-4455-83A3-C035FB6FB61A".toLowerCase();

    public customer: boolean = false;
    public location: boolean = false;
    public requestor: boolean = false;
    public projectManager: boolean = false;
    public buyer: boolean = false;
    public ship: boolean = false;
    public terms: boolean = false;
    public ise: boolean = false
    public dateRequested: boolean = false
    public dateExpected: boolean = false
    public refNum: boolean = false
    public creditCards: boolean = false
    public forEmployee: boolean = false
    public supplier: boolean = false
    public shipTo: boolean = false

    constructor(inStatus:string, rights?: AppClaims) {
        this.currentStatus = inStatus;
        if (rights && rights.EditCompletedOrder) {
            this.customer = true;
            this.location = true;
            this.requestor = true;
            this.projectManager = true;
            this.buyer = true;
            this.ship = true;
            this.terms = true;
            this.ise = true;
            this.dateRequested = true;
            this.dateExpected = true;
            this.refNum = true;
            this.creditCards = true;
            this.forEmployee = true;
            this.supplier = true;
            this.shipTo = true;
        } else {
            switch (inStatus) {
                case this.ordered: //1509
                    this.customer = false;
                    this.location = false;
                    this.requestor = false;
                    this.projectManager = true;
                    this.buyer = false;
                    this.ship = true;
                    this.terms = false;
                    this.ise = true;
                    this.dateRequested = true;
                    this.dateExpected = true;
                    this.refNum = true;
                    this.creditCards = true;
                    this.forEmployee = true;
                    this.supplier = true;
                    this.shipTo = true;
                    break
                case this.partiallyReceived:
                    this.customer = false;
                    this.location = false;
                    this.requestor = false;
                    this.projectManager = true;
                    this.buyer = false;
                    this.ship = true;
                    this.terms = false;
                    this.ise = true;
                    this.dateRequested = true;
                    this.dateExpected = true;
                    this.refNum = true;
                    this.creditCards = true;
                    this.forEmployee = true;
                    this.supplier = false;
                    this.shipTo = true;
                    break
                case this.fullyReceived:
                    this.customer = false;
                    this.location = false;
                    this.requestor = false;
                    this.projectManager = true;
                    this.buyer = false;
                    this.ship = false;
                    this.terms = false;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = true;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    break
                case this.billEntered:
                    this.customer = false;
                    this.location = false;
                    this.requestor = true;
                    this.buyer = false;
                    this.ship = false;
                    this.terms = false;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = true;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    break
                case this.canceled:
                    this.customer = false;
                    this.location = false;
                    this.requestor = false;
                    this.projectManager = true;
                    this.buyer = false;
                    this.ship = false;
                    this.terms = false;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = true;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    break
                case this.completed:
                    this.customer = false;
                    this.location = false;
                    this.requestor = false;
                    this.projectManager = true;
                    this.buyer = false;
                    this.ship = false;
                    this.terms = false;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = true;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    break
                default:
                    this.customer = true;
                    this.location = true;
                    this.requestor = true;
                    this.projectManager = true;
                    this.buyer = true;
                    this.ship = true;
                    this.terms = true;
                    this.ise = true;
                    this.dateRequested = true;
                    this.dateExpected = true;
                    this.refNum = true;
                    this.creditCards = true;
                    this.forEmployee = true;
                    this.supplier = true;
                    this.shipTo = true;
        }

        }
    }

}
